import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const NocService = {
    allArchivers: async (data) => axios.get(API_URL + "/archivers/getAllToSelect", data).then(({data}) => data).catch((err) => { throw err }),
    lastPassageTime: async (data) => axios.get(API_URL + "/noc-cameras/last-passage-time", data).then(({data}) => data).catch((err) => { throw err }),
    lastPassageImage: async (laneCode) => axios.get(API_URL + `/lanes/latest-passage/info/${laneCode}`).then(({data}) => data).catch((err) => { throw err }),
    getAllArchiversFilter: async (data) => axios.get(API_URL + "/archivers/getAllArchiversFilter", data).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
}

export default NocService;